import Toasted from 'vue-toasted'
import Vue from 'vue'
import 'material-icons/iconfont/material-icons.scss'

Vue.use(Toasted, {
  iconPack: 'material', // set your iconPack, defaults to material. material|fontawesome|custom-class
})
